<!-- 
**** IanOS App | IanOS Solution Project ****
**** Copyright 2025 ****
**** CHECKOUT TEMPLATE - Plantilla de Proceso de Compra ****
**** Características: Formulario de facturación, verificación de teléfono, métodos de pago, resumen de pedido ****
-->

<!-- Breadcrumb comentado - navegación de ubicación -->
<!--<app-breadcrumb [title]="'Checkout'" [breadcrumb]="'Checkout'"></app-breadcrumb>-->

<!-- **** SECCIÓN PRINCIPAL DEL CHECKOUT **** -->
<section class="section-b-space">
    <div class="container">
        <div class="checkout-page">
            <div class="checkout-form">
                <form>
                    <div class="row">

                        <!-- **** COLUMNA IZQUIERDA: DATOS DE FACTURACIÓN **** -->
                        <div class="col-lg-6 col-sm-12 col-xs-12">
                            <!-- Título de la sección de facturación -->
                            <div class="checkout-title">
                                <h3>Datos de facturación</h3>
                            </div>

                            <!-- **** FORMULARIO DE INFORMACIÓN PERSONAL **** -->
                            <div class="row check-out">

                                <!-- **** CAMPO NOMBRE **** -->
                                <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                    <div class="field-label">Nombre</div>
                                    <input type="text" class="form-control form-control-sm" [(ngModel)]="user.firstName"
                                        name="name" id="name" placeholder="Ingrese sus nombres">
                                    <!-- Validación de longitud mínima del nombre -->
                                    <div *ngIf="user.firstName.length < 3" class="text text-danger">
                                        El nombre debe contener al menos 3 caracteres
                                    </div>

                                    <!-- **** CÓDIGO COMENTADO - VALIDACIONES ORIGINALES **** -->
                                    <!--<input [readOnly]="true" type="text" name="firstname" [value]="user.firstName == '' ? 'default' : user.firstName" placeholder="" autocomplete="off">-->
                                    <!--<div *ngIf="checkoutForm.controls.firstname.touched && checkoutForm.controls.firstname.errors?.required" class="text text-danger">
                                        First Name is required.
                                    </div>
                                    <div *ngIf="checkoutForm.controls.firstname.touched && checkoutForm.controls.firstname.errors?.pattern" class="text text-danger">
                                        First Name must be an alphabates.
                                    </div>-->
                                </div>

                                <!-- **** CAMPO APELLIDO **** -->
                                <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                    <div class="field-label">Apellido</div>
                                    <input type="text" class="form-control form-control-sm" [(ngModel)]="user.lastName"
                                        id="last-name" name="last-name" placeholder="Ingrese sus apellidos">
                                    <!-- Validación de longitud mínima del apellido -->
                                    <div *ngIf="user.lastName.length < 3" class="text text-danger">
                                        El apellido debe contener al menos 3 caracteres
                                    </div>

                                    <!-- **** CÓDIGO COMENTADO - VALIDACIONES ORIGINALES **** -->
                                    <!--<input [readOnly]="true" type="text" name="lastname" [value]="user.lastName == '' ? 'default' : user.lastName" placeholder="" autocomplete="off">-->
                                    <!--<div *ngIf="checkoutForm.controls.lastname.touched && checkoutForm.controls.lastname.errors?.required" class="text text-danger">
                                        Last Name is required.
                                    </div>
                                    <div *ngIf="checkoutForm.controls.lastname.touched && checkoutForm.controls.lastname.errors?.pattern" class="text text-danger">
                                        Last Name must be an alphabates.
                                    </div>-->
                                </div>

                                <!-- **** CAMPO EMAIL (SOLO LECTURA) **** -->
                                <div class="form-group col-md-12 col-sm-12 col-xs-12">
                                    <div class="field-label">Dirección de correo electrónico</div>
                                    <!-- Muestra el email del usuario sin posibilidad de edición -->
                                    <p [textContent]="user.email"></p>

                                    <!-- **** CÓDIGO COMENTADO - VALIDACIONES ORIGINALES **** -->
                                    <!--<input [readOnly]="true" type="text" name="email" [value]="user.email == '' ? 'default' : user.email" placeholder="" autocomplete="off">-->
                                    <!--<div *ngIf="checkoutForm.controls.email.touched && checkoutForm.controls.email.errors?.required" class="text text-danger">
                                        Email is required
                                    </div>
                                    <div *ngIf="checkoutForm.controls.email.touched && checkoutForm.controls.email.errors?.email" class="text text-danger">
                                        Invalid Email
                                    </div>-->
                                </div>

                                <!-- **** SECCIÓN DE VERIFICACIÓN DE TELÉFONO **** -->
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                    <!-- Etiqueta que cambia de color según el estado de verificación -->
                                    <label [class]="user.verificate_phone ? 'text-success' : 'text-danger'"
                                        for="review">
                                        {{ user.verificate_phone ? 'Teléfono verificado' : 'Teléfono no verificado' }}
                                    </label>

                                    <!-- **** GRUPO DE ENTRADA DE TELÉFONO **** -->
                                    <div class="input-group">
                                        <!-- Selector de código de país -->
                                        <div style="width: 4rem" class="input-group-prepend">
                                            <select name="countries"
                                                [disabled]="countries.length == 0 || user.verificate_phone"
                                                (change)="onCountryChange()" class="form-control form-control-sm"
                                                [(ngModel)]="code">
                                                <option *ngFor="let country of countries"
                                                    [value]="getPhonePrefix(country)">
                                                    {{ getPhonePrefix(country) }} | {{ country.name['common'] }}
                                                </option>
                                            </select>
                                        </div>

                                        <!-- Campo de entrada del número de teléfono -->
                                        <input [disabled]="user.verificate_phone" class="form-control form-control-sm"
                                            [(ngModel)]="phone" id="review" name="review">

                                        <!-- Botón para enviar código de verificación (solo si no está verificado) -->
                                        <div *ngIf="!user.verificate_phone && active_verification_phone"
                                            class="input-group-append">
                                            <button class="btn btn-outline-secondary btn-sm"
                                                title="Enviar código de verificación"
                                                (click)="sendVerificationCode(phone)" type="button">
                                                Enviar código
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <!-- **** CAMPO DE CÓDIGO DE VERIFICACIÓN **** -->
                                <!-- Solo aparece después de enviar el código -->
                                <div *ngIf="send_verification_code" class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                                    <label for="code">Código de verificación</label>
                                    <div class="input-group">
                                        <!-- Campo con máscara para 6 dígitos -->
                                        <input class="form-control form-control-sm" [(ngModel)]="codeVerificationCheck"
                                            mask="000000" [showMaskTyped]="true" id="code" name="code">

                                        <!-- Botón para verificar el código ingresado -->
                                        <div class="input-group-append">
                                            <button class="btn btn-outline-info btn-sm"
                                                title="Verificar código de verificación"
                                                (click)="checkVerificationCode()" type="button">
                                                Verificar código
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- **** NOTA ADICIONAL DEL CHECKOUT **** -->
                            <!-- Muestra notas especiales si están activas -->
                            <ng-container *ngIf="noteCheckOut.active">
                                <h5>
                                    <strong>Nota:</strong>
                                </h5>
                                <p [innerHTML]="noteCheckOut.text"></p>
                            </ng-container>

                            <!-- **** SECCIÓN DE DIRECCIÓN DE ENVÍO **** -->
                            <ng-container *ngIf="(delivery_method || invoicing === 'Crédito Fiscal' || viewMap)">
                                <div *ngIf="currentLocation; else noLocationTemplate">
                                    <div class="checkout-title">
                                        <h3>{{ currentLocation.retrieved ? 'Ubicación actual' : 'Dirección guardada' }}
                                        </h3>
                                    </div>
                                    <div class="row check-out">
                                        <!-- Mapa -->
                                        <div class="col-xl-8" *ngIf="currentLocation.lat && currentLocation.lng">
                                            <div class="mb-3">
                                                <div style="width: 100%; height: 15rem;" #currentLocationMap
                                                    id="currentLocationMap"></div>
                                            </div>
                                        </div>

                                        <!-- Detalles -->
                                        <div class="col-xl-{{currentLocation.lat ? '4' : '12'}}">
                                            <div class="mb-2">
                                                <small class="text-muted">Coordenadas:</small>
                                                <div>{{ currentLocation.lat | number:'1.4-4' }}, {{ currentLocation.lng
                                                    | number:'1.4-4' }}</div>
                                            </div>
                                            <div class="mb-2" *ngIf="currentLocation.address">
                                                <small class="text-muted">Dirección:</small>
                                                <div>{{ currentLocation.address }}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Mensaje contextual -->
                                    <div class="alert alert-{{currentLocation.retrieved ? 'info' : 'warning'}} mt-3">
                                        {{ currentLocation.retrieved ? 'Ubicación obtenida en tiempo real. Verifica que
                                        sea correcta.' : 'Usando tu dirección guardada (actualiza si necesitas
                                        cambios).' }}
                                        <a [routerLink]="'/pages/profile'" class="ms-2">Editar direcciones</a>
                                    </div>
                                </div>

                                <!-- Plantilla cuando no hay ubicación -->
                                <ng-template #noLocationTemplate>
                                    <div class="alert alert-danger">
                                        <i class="fa fa-exclamation-triangle me-2"></i>
                                        Por favor <a [routerLink]="'/pages/profile'">agrega una dirección</a> o habilita
                                        permisos de ubicación.
                                    </div>
                                </ng-template>
                            </ng-container>


                            <div [hidden]="true" class="row">
                                <div class="col-12">
                                    <div class="stripe-section">
                                        <h5>stripe js</h5>
                                        <div class="content">
                                            <h5>dummy test</h5>
                                            <table>
                                                <tr>
                                                    <td>cart number</td>
                                                    <td>4242424242424242</td>
                                                </tr>
                                                <tr>
                                                    <td>mm/yy</td>
                                                    <td>2/2020</td>
                                                </tr>
                                                <tr>
                                                    <td>cvc</td>
                                                    <td>2222</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Información de prueba para PayPal (oculta) -->
                            <div [hidden]="true" class="row margin-cls">
                                <div class="col-12">
                                    <div class="stripe-section">
                                        <h5>paypal</h5>
                                        <div class="content">
                                            <h5>dummy test</h5>
                                            <table>
                                                <tr>
                                                    <td>cart number</td>
                                                    <td>4152521541244</td>
                                                </tr>
                                                <tr>
                                                    <td>mm/yy</td>
                                                    <td>11/18</td>
                                                </tr>
                                                <tr>
                                                    <td>cvc</td>
                                                    <td>521</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- **** COLUMNA DERECHA: RESUMEN DE PEDIDO **** -->
                        <div class="col-lg-6 col-sm-12 col-xs-12">
                            <div class="checkout-details p-4">
                                <div class="order-box">

                                    <!-- **** ENCABEZADO DE PRODUCTOS **** -->
                                    <div class="title-box">
                                        <div>Producto <span> Total</span></div>
                                    </div>

                                    <!-- **** LISTA DE PRODUCTOS EN EL CARRITO **** -->
                                    <!-- Muestra productos si existen -->
                                    <ul class="qty" *ngIf='products.length'>
                                        <li *ngFor="let product of products">
                                            {{ product.title }} × {{ product.quantity }}
                                            <span>
                                                {{ (product.price | discount:product) * productService?.Currency.price |
                                                currency:productService?.Currency.currency:'symbol' }}
                                            </span>
                                        </li>
                                    </ul>

                                    <!-- Mensaje cuando no hay productos -->
                                    <ul class="qty" *ngIf='!products.length'>
                                        <li class="empty-checkout">No hay productos en el carrito</li>
                                    </ul>

                                    <!-- **** SECCIÓN DE CONFIGURACIÓN DE PEDIDO **** -->
                                    <ul class="sub-total">
                                        <!-- **** CÓDIGO COMENTADO - SUBTOTAL ALTERNATIVO **** -->
                                        <!--<li>
                                            Subtotal <span class="count">{{ getTotal | async | currency:productService?.Currency.currency:'symbol'}}</span>
                                        </li>-->

                                        <!-- Solo aparece si hay productos -->
                                        <li *ngIf='products.length'>
                                            <div class="row">

                                                <!-- **** SELECTOR DE MÉTODO DE ENVÍO **** -->
                                                <div class="col-lg-6 select_input my-1">
                                                    <label for="country">Método de envio</label>
                                                    <select (change)="metodoEnvio($event.target.value)" id="country"
                                                        name="country" [(ngModel)]="shipping"
                                                        class="form-control form-control-sm" size="1">
                                                        <option value="">Seleccione metodo envio</option>
                                                        <ng-container *ngFor="let item of methodShipping">
                                                            <option *ngIf="item.active" [value]="item.name">
                                                                {{item.name}}
                                                            </option>
                                                        </ng-container>
                                                    </select>

                                                    <!-- Mensaje adicional del método de pago -->
                                                    <label *ngIf="txtMessage">
                                                        <span class="small-text" [innerHtml]="txtMessage"></span>
                                                    </label>
                                                </div>


                                                <!-- **** SELECTOR DE TIPO DE ENTREGA PERSONALIZADA **** -->
                                                <!-- Solo aparece para delivery personalizado -->
                                                <div class="col-lg-6 select_input my-1"
                                                    *ngIf="infoGeneral.delivery_disabled && infoGeneral.delivery_custom_active && shipping == 'Delivery'">
                                                    <label for="typeDelivery">Tipo de Entrega</label>
                                                    <select (change)="tipoEnvio($event.target.value)" id="typeDelivery"
                                                        name="typeDelivery" [(ngModel)]="shippingTypeDelivery"
                                                        class="form-control form-control-sm" size="1">
                                                        <option value="">Seleccione tipo de entrega</option>
                                                        <ng-container *ngFor="let item of listCostCustomDelivery">
                                                            <option [value]="item.uid">{{item.name}}</option>
                                                        </ng-container>
                                                    </select>
                                                </div>

                                                <!-- **** SELECTOR DE TIPO DE DOCUMENTO **** -->
                                                <div class="col-lg-6 select_input my-1">
                                                    <label for="country">Documento a generar</label>
                                                    <select (change)="documentoGenerar($event.target.value)"
                                                        id="invoicing" name="invoicing" [(ngModel)]="invoicing"
                                                        class="form-control form-control-sm" size="1">
                                                        <option value="">Seleccione documento a generar</option>
                                                        <ng-container *ngFor="let item of methodInvoicing">
                                                            <option *ngIf="item.active" [value]="item.name">
                                                                {{item.name}}
                                                            </option>
                                                        </ng-container>
                                                    </select>
                                                </div>

                                                <!-- **** SELECTOR DE SUCURSAL **** -->
                                                <!-- Solo aparece para retiro en sucursal -->
                                                <div class="col-lg-6 select_input my-1">
                                                    <label for="country">Sucursal (Recomendada)</label>
                                                    <select (change)="sucursalRetiro($event.target.value)" id="sucursal"
                                                        name="sucursal" [(ngModel)]="sucursal"
                                                        class="form-control form-control-sm" size="1">
                                                        <option value="">Sucursal Retiro</option>
                                                        <ng-container *ngFor="let item of sucursales; let i = index">
                                                            <option [value]="item.company_dba_name">
                                                                {{item.company_dba_name}}
                                                            </option>
                                                        </ng-container>
                                                    </select>
                                                </div>

                                                <!-- Espacio vacío para alineación -->
                                                <div *ngIf="shipping == 'Retiro en sucursal'"
                                                    class="col-lg-6 select_input">
                                                </div>

                                                <!-- **** SELECTOR DE MÉTODO DE PAGO **** -->
                                                <div class="col-lg-6 select_input my-1">
                                                    <label for="country">Método Pago</label>
                                                    <select (change)="paymentMethod($event.target.value)" id="pago"
                                                        name="pago" [(ngModel)]="pago"
                                                        class="form-control form-control-sm" size="1">
                                                        <option value="">Seleccione metodo pago</option>
                                                        <ng-container *ngFor="let item of metodoPago; let i = index">
                                                            <option *ngIf="item.active" [value]="item.name">
                                                                {{item.name}}
                                                            </option>
                                                        </ng-container>
                                                    </select>

                                                    <!-- Mensaje adicional del método de pago -->
                                                    <label *ngIf="txtMessage">
                                                        <span class="small-text" [innerHtml]="txtMessage"></span>
                                                    </label>
                                                </div>


                                                <!-- **** CAMPO DE TARJETA STRIPE **** -->
                                                <!-- Solo aparece para pagos con Stripe -->
                                                <div [hidden]="!isStripe"
                                                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-1">
                                                    <label for="card">Número de tarjeta</label>
                                                    <div id="card-element" #cardElement>
                                                        <!-- Elemento de entrada de tarjeta de Stripe se renderizará aquí -->
                                                    </div>
                                                    <!-- Contenedor para mostrar errores de Stripe -->
                                                    <div id="card-errors" role="alert"></div>
                                                </div>

                                                <!-- **** OPCIÓN DE USAR CRÉDITOS **** -->
                                                <!-- Solo aparece si hay wallet activo y créditos disponibles -->
                                                <div *ngIf="isWallet && pago!= '' && total_wallet > 0"
                                                    class="col text-nowrap d-flex align-items-center">
                                                    <div class="form-check form-switch mb-2">
                                                        <input type="checkbox" [(ngModel)]="used_credits"
                                                            (change)="getNewTotal()" class="form-check-input"
                                                            id="wallet" name="wallet">
                                                        <label class="form-check-label" for="wallet">&nbsp; use credits
                                                            &nbsp;</label>
                                                        <p style="font-size: 0.7rem">Total available: {{
                                                            this.total_wallet |
                                                            currency:productService?.Currency.currency:'symbol' }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>

                                    <!-- **** DESGLOSE DE TOTALES **** -->
                                    <ul class="total">
                                        <!-- Subtotal -->
                                        <li class="fs-6">Subtotal
                                            <span>{{ getSubtotal() |
                                                currency:productService?.Currency.currency:'symbol'}}</span>
                                        </li>

                                        <!-- Comisión de servicio (si no está incluida) -->
                                        <li *ngIf="!include_service_fee" class="fs-6">Service Fee
                                            <span>{{ serviceFee() |
                                                currency:productService?.Currency.currency:'symbol'}}</span>
                                        </li>

                                        <!-- Impuestos (si están visibles) -->
                                        <li *ngIf="view_tax" class="fs-6">Tax
                                            <span>{{ getTax() |
                                                currency:productService?.Currency.currency:'symbol'}}</span>
                                        </li>

                                        <!-- Costo de envío (si es delivery) -->
                                        <li *ngIf="delivery_method && method_shipping !== ''"
                                            class="fs-6 text-capitalize">
                                            {{method_shipping}}
                                            <span>{{ getDelivery() |
                                                currency:productService?.Currency.currency:'symbol'}}</span>
                                        </li>

                                        <!-- Créditos usados -->
                                        <li *ngIf="used_credits" class="fs-6">Credits
                                            <span> - {{ total_credits_used |
                                                currency:productService?.Currency.currency:'symbol'}}</span>
                                        </li>
                                    </ul>

                                    <!-- **** TOTAL FINAL **** -->
                                    <ul class="sub-total">
                                        <!-- **** CÓDIGO COMENTADO - TOTAL ALTERNATIVO **** -->
                                        <!--<li>Total <span class="count">{{ getTotal | async | currency:productService?.Currency.currency:'symbol'}}</span></li>-->
                                        <li>Total
                                            <span class="count">{{ getNewTotal() |
                                                currency:productService?.Currency.currency:'symbol'}}</span>
                                        </li>
                                    </ul>
                                </div>

                                <!-- **** SECCIÓN DE BOTONES DE PAGO **** -->
                                <!-- Solo aparece si hay productos -->
                                <div class="payment-box" *ngIf='products.length'>
                                    <div class="upper-box">
                                        <div class="payment-options">
                                            <ul>

                                                <!-- **** OPCIONES DE PAGO OCULTAS **** -->
                                                <!-- Opción Stripe (oculta) -->
                                                <li [hidden]="true">
                                                    <div class="radio-option">
                                                        <input type="radio" [(ngModel)]="payment" [value]="'Stripe'"
                                                            name="payment-group" id="payment-2">
                                                        <label for="payment-2">Stripe
                                                            <span class="small-text">Please send a check to Store Name,
                                                                Store Street, Store Town, Store State / County, Store
                                                                Postcode.</span>
                                                        </label>
                                                    </div>
                                                </li>

                                                <!-- **** OPCIÓN PAYPAL COMENTADA **** -->
                                                <!--<li>
                                                    <div class="radio-option paypal">
                                                        <input type="radio" [(ngModel)]="payment" [value]="'Paypal'" name="payment-group" id="payment-3">
                                                        <label for="payment-3">PayPal<span class="image"><img src="assets/images/paypal.png" alt=""/></span></label>
                                                    </div>
                                                </li>-->

                                                <!-- Opción Wompi (oculta) -->
                                                <li [hidden]="true">
                                                    <div class="radio-option wompi">
                                                        <input type="radio" [(ngModel)]="payment" [value]="'Wompi'"
                                                            name="payment-group" id="payment-3">
                                                        <label for="payment-2">Wompi
                                                            <span class="small-text">Please send a check to Store Name,
                                                                Store Street, Store Town, Store State / County, Store
                                                                Postcode.</span>
                                                        </label>
                                                    </div>
                                                </li>

                                                <!-- **** MENSAJE DE VERIFICACIÓN DE TELÉFONO **** -->
                                                <!-- Aparece si falta verificar el teléfono -->
                                                <li
                                                    *ngIf="shipping != '' && invoicing != '' && sucursal != '' && pago!= '' && !user.verificate_phone">
                                                    <label for="payment-2">
                                                        <span class="small-text">
                                                            Estimado usuario, con el metodo de pago seleccionado, es
                                                            necesario que nos proporcione un numero de contacto para
                                                            poder comunicarnos con usted para poder dar
                                                            seguimiento al estado de su pedido.
                                                            <br>
                                                            Para actualizar la informacion de su contacto, puede dar
                                                            clic en el siguiente enlace.
                                                            <a [routerLink]="'/pages/profile'">Actualizar</a>
                                                        </span>
                                                    </label>
                                                </li>

                                                <!-- **** MENSAJE DE TRANSFERENCIA BANCARIA **** -->
                                                <!-- Aparece para métodos de pago que no son Wompi ni efectivo -->
                                                <li
                                                    *ngIf="!isWompi && !isCash && shipping != '' && invoicing != '' && sucursal!= '' && pago!= ''">
                                                    <label for="payment-2">
                                                        <span class="small-text">
                                                            Estimado usuario, si en 24h su pedido no está pagado por
                                                            transferencia bancaria, el pedido se cancelará
                                                            automáticamente y los productos estarán disponibles para su
                                                            compra
                                                        </span>
                                                    </label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div *ngIf="isPowerTranz && savedCards.length > 0"
                                        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-3">
                                        <label class="form-label">Seleccionar Tarjeta Guardada</label>

                                        <div class="row">
                                            <div *ngIf="isPowerTranz" class="col-xl-12 mb-3">
                                                <button class="btn btn-outline-primary w-100"
                                                    (click)="payWithNewCard()">
                                                    Agregar nueva tarjeta
                                                </button>
                                            </div>

                                            <div *ngFor="let card of savedCards" class="col-md-6 mb-2">
                                                <!-- Agregar (click) aquí y cursor pointer -->
                                                <div class="card border" [ngClass]="{
                 'border-primary': selectedCard?.id === card.id && !shownewCardForm,
                 'border-secondary': selectedCard?.id !== card.id || shownewCardForm
             }" (click)="!shownewCardForm && onCardSelected(card)"
                                                    [style.cursor]="shownewCardForm ? 'not-allowed' : 'pointer'"
                                                    [style.opacity]="shownewCardForm ? '0.6' : '1'">

                                                    <div class="card-body p-2">
                                                        <div
                                                            class="form-check d-flex justify-content-between align-items-start">
                                                            <div class="flex-grow-1">
                                                                <!-- El input se mantiene pero solo como indicador visual -->
                                                                <input class="form-check-input" type="radio"
                                                                    [id]="'card-' + card.id" name="selectedCard"
                                                                    [value]="card.id"
                                                                    [checked]="selectedCard?.id === card.id && !shownewCardForm"
                                                                    [disabled]="shownewCardForm"
                                                                    style="pointer-events: none;">

                                                                <label
                                                                    class="form-check-label d-flex align-items-center"
                                                                    [for]="'card-' + card.id"
                                                                    style="cursor: inherit; pointer-events: none;">

                                                                    <i class="fa" [ngClass]="{
                                'fa-cc-visa': card.brand.toLowerCase() === 'visa',
                                'fa-cc-mastercard': card.brand.toLowerCase() === 'mastercard',
                                'fa-credit-card': !['visa', 'mastercard'].includes(card.brand.toLowerCase())
                            }" style="font-size: 1.5rem; margin-right: 0.5rem;"></i>

                                                                    <div>
                                                                        <div class="fw-bold"> {{card.last_digits}}</div>
                                                                        <small class="text-muted">
                                                                            {{card.brand | titlecase}}
                                                                        </small>
                                                                        <div class="small text-muted">
                                                                            {{card.card_holder_name}}</div>
                                                                    </div>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>



                                    <!-- **** FORMULARIO PARA AGREGAR NUEVA TARJETA **** -->
                                    <!-- FORMULARIO PARA AGREGAR NUEVA TARJETA - CORREGIDO -->
                                    <div *ngIf="shownewCardForm && isPowerTranz"
                                        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-3">
                                        <div class="card border-info">
                                            <div
                                                class="card-header bg-info text-white d-flex justify-content-between align-items-center">
                                                <h6 class="mb-0">Agregar Nueva Tarjeta</h6>
                                                <button type="button" class="btn btn-sm btn-outline-light"
                                                    (click)="cancelAddCard()">
                                                    <i class="fa fa-times"></i>
                                                </button>
                                            </div>
                                            <div class="card-body">
                                                <form [formGroup]="newCardForm" *ngIf="newCardForm">
                                                    <div class="row">
                                                        <!-- Nombre del titular -->
                                                        <div class="col-md-12 mb-3">
                                                            <label class="form-label">Nombre del titular <span
                                                                    class="text-danger">*</span></label>
                                                            <input type="text" class="form-control form-control-sm"
                                                                formControlName="cardHolderName"
                                                                placeholder="Nombre completo como aparece en la tarjeta"
                                                                [class.is-invalid]="newCardForm.get('cardHolderName')?.touched && newCardForm.get('cardHolderName')?.errors">

                                                            <!-- VALIDACIONES MEJORADAS -->
                                                            <div *ngIf="newCardForm.get('cardHolderName')?.touched && newCardForm.get('cardHolderName')?.errors"
                                                                class="text-danger small">
                                                                <div
                                                                    *ngIf="newCardForm.get('cardHolderName')?.errors?.['required']">
                                                                    El nombre es requerido
                                                                </div>
                                                                <div
                                                                    *ngIf="newCardForm.get('cardHolderName')?.errors?.['minlength']">
                                                                    El nombre debe tener al menos 2 caracteres
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <!-- Número de tarjeta -->
                                                        <div class="col-md-8 mb-3">
                                                            <label class="form-label">Número de tarjeta <span
                                                                    class="text-danger">*</span></label>
                                                            <input type="text" class="form-control form-control-sm"
                                                                formControlName="cardNumber"
                                                                placeholder="1234 5678 9012 3456"
                                                                mask="0000 0000 0000 0000" [showMaskTyped]="false"
                                                                [class.is-invalid]="newCardForm.get('cardNumber')?.touched && newCardForm.get('cardNumber')?.errors">

                                                            <div *ngIf="newCardForm.get('cardNumber')?.touched && newCardForm.get('cardNumber')?.errors"
                                                                class="text-danger small">
                                                                <div
                                                                    *ngIf="newCardForm.get('cardNumber')?.errors?.['required']">
                                                                    El número de tarjeta es requerido
                                                                </div>
                                                                <div
                                                                    *ngIf="newCardForm.get('cardNumber')?.errors?.['pattern']">
                                                                    Número de tarjeta inválido (debe tener entre 13-19
                                                                    dígitos)
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <!-- CVV -->
                                                        <div class="col-md-4 mb-3">
                                                            <label class="form-label">CVV <span
                                                                    class="text-danger">*</span></label>
                                                            <input type="password" class="form-control form-control-sm"
                                                                formControlName="cvv" placeholder="123" maxlength="4"
                                                                [class.is-invalid]="newCardForm.get('cvv')?.touched && newCardForm.get('cvv')?.errors">

                                                            <div *ngIf="newCardForm.get('cvv')?.touched && newCardForm.get('cvv')?.errors"
                                                                class="text-danger small">
                                                                <div
                                                                    *ngIf="newCardForm.get('cvv')?.errors?.['required']">
                                                                    El CVV es requerido
                                                                </div>
                                                                <div
                                                                    *ngIf="newCardForm.get('cvv')?.errors?.['pattern']">
                                                                    CVV inválido (3-4 dígitos)
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <!-- Fecha de expiración -->
                                                        <div class="col-md-6 mb-3">
                                                            <label class="form-label">Mes de expiración <span
                                                                    class="text-danger">*</span></label>
                                                            <select class="form-control form-control-sm"
                                                                formControlName="expMonth"
                                                                [class.is-invalid]="newCardForm.get('expMonth')?.touched && newCardForm.get('expMonth')?.errors">
                                                                <option value="">Mes</option>
                                                                <option value="01">01 - Enero</option>
                                                                <option value="02">02 - Febrero</option>
                                                                <option value="03">03 - Marzo</option>
                                                                <option value="04">04 - Abril</option>
                                                                <option value="05">05 - Mayo</option>
                                                                <option value="06">06 - Junio</option>
                                                                <option value="07">07 - Julio</option>
                                                                <option value="08">08 - Agosto</option>
                                                                <option value="09">09 - Septiembre</option>
                                                                <option value="10">10 - Octubre</option>
                                                                <option value="11">11 - Noviembre</option>
                                                                <option value="12">12 - Diciembre</option>
                                                            </select>

                                                            <div *ngIf="newCardForm.get('expMonth')?.touched && newCardForm.get('expMonth')?.errors?.['required']"
                                                                class="text-danger small">
                                                                El mes de expiración es requerido
                                                            </div>
                                                        </div>

                                                        <div class="col-md-6 mb-3">
                                                            <label class="form-label">Año de expiración <span
                                                                    class="text-danger">*</span></label>
                                                            <select class="form-control form-control-sm"
                                                                formControlName="expYear"
                                                                [class.is-invalid]="newCardForm.get('expYear')?.touched && newCardForm.get('expYear')?.errors">
                                                                <option value="">Año</option>
                                                                <option *ngFor="let year of getExpirationYears()"
                                                                    [value]="year">
                                                                    20{{year}}
                                                                </option>
                                                            </select>

                                                            <div *ngIf="newCardForm.get('expYear')?.touched && newCardForm.get('expYear')?.errors?.['required']"
                                                                class="text-danger small">
                                                                El año de expiración es requerido
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-12 mb-3">
                                                        <div class="form-check">
                                                            <input type="checkbox" class="form-check-input"
                                                                [(ngModel)]="saveCard"
                                                                [ngModelOptions]="{standalone: true}"
                                                                id="saveCardCheckbox">
                                                            <label class="form-check-label" for="saveCardCheckbox">
                                                                <i class="fa fa-save me-1"></i>
                                                                Guardar esta tarjeta para futuras compras
                                                            </label>
                                                            <small class="d-block text-muted mt-1">
                                                                Tu tarjeta será guardada de forma segura y tokenizada
                                                            </small>
                                                        </div>
                                                    </div>


                                                    <!-- Botones del formulario -->
                                                    <div class="d-flex justify-content-end">
                                                        <button type="button" class="btn btn-secondary btn-sm"
                                                            (click)="cancelNewCard()">
                                                            <i class="fa fa-times me-1"></i>
                                                            Cerrar Formulario
                                                        </button>
                                                    </div>


                                                    <!-- DEBUG: Mostrar estado del formulario (remover en producción) -->
                                                    <div class="mt-2" *ngIf="!newCardForm.valid">
                                                        <small class="text-muted">
                                                            Formulario inválido. Verifica todos los campos.
                                                        </small>
                                                    </div>
                                                </form>

                                                <!-- Mensaje si el formulario no se inicializó -->
                                                <div *ngIf="!newCardForm" class="alert alert-warning">
                                                    <i class="fa fa-exclamation-triangle"></i>
                                                    Error al inicializar el formulario. Por favor recarga la página.
                                                </div>
                                            </div>
                                        </div>
                                    </div>




                                    <!-- **** MENSAJE PARA AGREGAR PRIMERA TARJETA **** -->
                                    <div *ngIf="isPowerTranz && savedCards.length === 0 && !shownewCardForm"
                                        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-3">
                                        <div class="card border-warning">
                                            <div class="card-body text-center">
                                                <i class="fa fa-credit-card text-warning" style="font-size: 3rem;"></i>
                                                <h6 class="mt-2">No tienes tarjetas guardadas</h6>
                                                <p class="text-muted small mb-3">Agrega tu primera tarjeta para
                                                    continuar con el pago</p>
                                                <button type="button" class="btn btn-warning btn-sm"
                                                    (click)="shownewCardForm = true">
                                                    <i class="fa fa-plus me-1"></i>
                                                    Agregar Tarjeta
                                                </button>
                                            </div>
                                        </div>
                                    </div>



                                    <!-- **** BOTONES DE ACCIÓN **** -->
                                    <!-- **** BOTÓN ÚNICO DE ACCIÓN **** -->
                                    <div class="text-end">
                                        <ng-container *ngIf="!verify">

                                            <!-- BOTÓN WOMPI -->
                                            <button *ngIf="isWompi" [disabled]="user.email == ''" type="submit"
                                                class="btn-solid btn mx-2" (click)="pagoWompi(content)">
                                                <i class="fa fa-credit-card me-2"></i>
                                                Pagar con Wompi
                                            </button>

                                            <!-- BOTÓN POWERTRANZ -->
                                            <button *ngIf="isPowerTranz"
                                                [disabled]="user.email == '' || (!selectedCard && !shownewCardForm) || (shownewCardForm && !newCardForm.valid)"
                                                type="submit" class="btn-solid btn mx-2" (click)="confirmarPedido()">
                                                <i class="fa fa-credit-card me-2"></i>
                                                <!-- ✅ Mensaje dinámico según el estado -->
                                                <ng-container *ngIf="shownewCardForm && newCardForm.valid">
                                                    Pagar con Nueva Tarjeta
                                                </ng-container>
                                                <ng-container *ngIf="selectedCard && !shownewCardForm">
                                                    Pagar con {{selectedCard.last_digits}}
                                                </ng-container>
                                                <ng-container *ngIf="!selectedCard && !shownewCardForm">
                                                    Selecciona método de pago
                                                </ng-container>
                                            </button>


                                            <!-- BOTÓN OTROS MÉTODOS (Efectivo, Transferencia, etc) -->
                                            <button *ngIf="!isWompi && !isPowerTranz" [disabled]="user.email == ''"
                                                type="submit" class="btn-solid btn mx-2" (click)="confirmarPedido()">
                                                <i class="fa fa-check-circle me-2"></i>
                                                Confirmar Pedido
                                            </button>

                                            <!-- MENSAJES DE VALIDACIÓN POWERTRANZ -->
                                            <div *ngIf="isPowerTranz && !selectedCard && !showNewCardForm"
                                                class="alert alert-warning mt-3 mb-0">
                                                <i class="fa fa-exclamation-triangle me-2"></i>
                                                <strong>Selecciona una tarjeta o agrega una nueva para
                                                    continuar</strong>
                                            </div>

                                            <div *ngIf="isPowerTranz && showNewCardForm && !newCardForm.valid"
                                                class="alert alert-info mt-3 mb-0">
                                                <i class="fa fa-info-circle me-2"></i>
                                                <strong>Completa todos los campos de la tarjeta para proceder con el
                                                    pago</strong>
                                            </div>

                                        </ng-container>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</section>

<!-- **** MODAL DE PAGO WOMPI **** -->
<ng-template #content let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Pasarela de pago Wompi</h4>
        <!-- **** BOTÓN CERRAR COMENTADO **** -->
        <!--<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('se arrepintió')"></button>-->
    </div>

    <!-- **** CUERPO DEL MODAL **** -->
    <!-- Contiene el iframe de la pasarela de pago -->
    <div class="modal-body">
        <iframe class="w-100 h-100" [src]="urlPayment"></iframe>
    </div>

    <!-- **** BOTONES DEL MODAL **** -->
    <div class="modal-footer">
        <!-- Botón para cancelar el pago -->
        <button *ngIf="verify" type="submit" class="btn-solid btn mx-2" (click)="cancelPaymentWompi()">
            Cancelar pago
        </button>

        <!-- Botón para confirmar el pago -->
        <button *ngIf="verify" type="submit" class="btn-solid btn mx-2" (click)="confirmParymentWompi()">
            Confirmar pago
        </button>
    </div>
</ng-template>

<!-- **** TABLA DE FACTURA OCULTA **** -->
<!-- Tabla utilizada para generar el contenido del email de factura -->
<div hidden>
    <table id="table-invoice" cellpadding="0" cellspacing="0" class="esdev-mso-table"
        style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;width:560px">

        <!-- **** FILA POR CADA PRODUCTO **** -->
        <tr *ngFor="let item of products" style="border-top: 2px solid #e9e9e9;">

            <!-- **** CELDA DEL NOMBRE DEL PRODUCTO **** -->
            <td class="esdev-mso-td" valign="top" style="padding:0;Margin:0">
                <table cellpadding="0" cellspacing="0" class="es-left" align="left"
                    style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:left">
                    <tr>
                        <td class="es-m-p0r" align="center" style="padding:0;Margin:0;width:265px">
                            <table cellpadding="0" cellspacing="0" width="100%" role="presentation"
                                style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                <tr>
                                    <td align="left" style="padding:0;Margin:0">
                                        <p
                                            style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, 'helvetica neue', helvetica, sans-serif;line-height:21px;color:#333333;font-size:14px">
                                            <b>{{item.title}}</b>
                                        </p>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            </td>

            <!-- Separador -->
            <td style="padding:0;Margin:0;width:10px"></td>

            <!-- **** CELDA DE CANTIDAD **** -->
            <td class="esdev-mso-td" valign="top" style="padding:0;Margin:0">
                <table cellpadding="0" cellspacing="0" class="es-left" align="left"
                    style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:left">
                    <tr>
                        <td align="center" style="padding:0;Margin:0;width:70px">
                            <table cellpadding="0" cellspacing="0" width="100%" role="presentation"
                                style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                <tr>
                                    <td align="center" style="padding:0;Margin:0">
                                        <p
                                            style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, 'helvetica neue', helvetica, sans-serif;line-height:21px;color:#333333;font-size:14px">
                                            <b>{{item.quantity}}</b>
                                        </p>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            </td>

            <!-- Separador -->
            <td style="padding:0;Margin:0;width:20px"></td>

            <!-- **** CELDA DE PRECIO UNITARIO **** -->
            <td class="esdev-mso-td" valign="top" style="padding:0;Margin:0">
                <table cellpadding="0" cellspacing="0" class="es-left" align="left"
                    style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:left">
                    <tr>
                        <td align="left" style="padding:0;Margin:0;width:80px">
                            <table cellpadding="0" cellspacing="0" width="100%" role="presentation"
                                style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                <tr>
                                    <td align="center" style="padding:0;Margin:0">
                                        <p
                                            style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, 'helvetica neue', helvetica, sans-serif;line-height:21px;color:#333333;font-size:14px">
                                            <b>{{ (item.price | discount:item) * productService?.Currency.price |
                                                currency:productService?.Currency.currency:'symbol' }}</b>
                                        </p>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            </td>

            <!-- Separador -->
            <td style="padding:0;Margin:0;width:20px"></td>

            <!-- **** CELDA DE PRECIO TOTAL **** -->
            <td class="esdev-mso-td" valign="top" style="padding:0;Margin:0">
                <table cellpadding="0" cellspacing="0" class="es-right" align="right"
                    style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:right">
                    <tr>
                        <td align="left" style="padding:0;Margin:0;width:85px">
                            <table cellpadding="0" cellspacing="0" width="100%" role="presentation"
                                style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                <tr>
                                    <td align="right" style="padding:0;Margin:0">
                                        <p
                                            style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, 'helvetica neue', helvetica, sans-serif;line-height:21px;color:#333333;font-size:14px">
                                            <b>{{ (item.price | discount:item) * productService?.Currency.price |
                                                currency:productService?.Currency.currency:'symbol' }}</b>
                                        </p>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
</div>